import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {productUpdateStockTableReady,rowsPerPageState,searchTextState,paginationState} from '../redux/products_stocks'
import { headerDataUpdate,subHeaderDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'
import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import CollapsibleRow from './CollapsibleRow'
import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/productsStocksTable.css'
//import * as Helpers from '../../../common/helpers'

function filterUnwantedData(stocksData) {
    let array = []
    if (stocksData && stocksData.data && stocksData.data.list) {
        array = stocksData.data.list
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            //let defaultAddress = "NA", companyName ="NA"
            let lineData = array[i]
            lineData.kit_name=lineData.kit.sku_name
            lineData.kit_number=lineData.kit.sku_number
            lineData.checked=false
            let store_kits = []
            
            for (let j = 0; j < lineData.kit.store_kits.length; j++) {
                store_kits[j]={
                    "store_kit_id":lineData.kit.store_kits[j].id,
                    "status":lineData.kit.store_kits[j].status,
                    "store_id":lineData.kit.store_kits[j].store.id,
                    "store_name":lineData.kit.store_kits[j].store.name,
                    "checked":true
                    }
                    
            }   
            lineData.store_kits=store_kits;

            newArray[i] = lineData
        }
    }
    return newArray
}

class ProductUpdateStockTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            productStocksData: [],
            productSelected:{},
            bodyHeight: "0px",
            tableHeight: "0px",
            rowCount: 15,
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: "",
            onExpandableRowClicked: false,
            expandedRowData: "",
        }
        this.isComponentMounted = true
        this.cityComponent = null
        this.dialog = null
        this.searchBox = null
    }

    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(productUpdateStockTableReady(false))

        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()

        this.getProductStocksData()
    }

    componentDidMount() {
    }
   

    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 230) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }
    
    getProductStocksData = () => {

           if(this.props.products_stocks && this.props.products_stocks.productSelected && this.props.products_stocks.productSelected !== null){
            
            this.props.dispatch(headerDataUpdate(Constants.PRODUCTS_UPDATE_STOCKS_TABLE))

            if(this.props.products_stocks.productSelected.stock_status==="Stock in"){
                this.props.dispatch(subHeaderDataUpdate(" - "+this.props.products_stocks.productSelected.sku_name+" - Stock Out Wizard"))
            }else{
                this.props.dispatch(subHeaderDataUpdate(" - "+this.props.products_stocks.productSelected.sku_name+" - Stock In Wizard"))
            

            }            let prevProductData= this.props.products_stocks.productSelected                
                        this.setState({
                            productSelected:prevProductData
                        })


        apiService.getProductUpdateStockStocksData(this.props.products_stocks.productSelected.id)
            .then(responseData => {
                if (responseData) {
                    this.validateBuildNumber(responseData)
                    if (responseData.status === "SUCCESS") {
                        let array = filterUnwantedData(responseData), pageNo = 1
                        if (this.props.products_stocks && this.props.products_stocks.previousPaginationValue) {
                            pageNo = this.props.products_stocks.previousPaginationValue
                        }
                        this.setState({
                            productStocksData: array,
                            page: pageNo,
                        })
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
                this.props.dispatch(productUpdateStockTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(productUpdateStockTableReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })

        }
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.products_stocks && this.props.products_stocks.previousRowsPerPageValue) {
            value = this.props.products_stocks.previousRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsPerPageState(value))
        this.dropUpManager()
    }

    expandComponent = row => {
        let row_id = ""
        if (row && row.id) {
            row_id = row.id
        }
        return <CollapsibleRow row={row} row_id={row_id} getProductStocksData={this.getProductStocksData} />
    }

    isExpandableRow = row => {
        return true
    }

    expandColumnComponent = ({ isExpandableRow, isExpanded }) => {
        let downIconClassName = ""
        if (isExpandableRow) {
            downIconClassName = (isExpanded ? 'fa fa-angle-double-up' : 'fa fa-angle-double-down')
        } else {
            downIconClassName = ""
        }
        return (
            <div className="custom-expandable-row-indicator">
                <span className={downIconClassName} />
            </div>
        )
    }



    updateStock = () => {

         this.props.dispatch(productUpdateStockTableReady(false))

    let prodStocksData=this.state.productStocksData.slice();
    //let added=[]
    let store_kits=[]
        prodStocksData.map(function(item) {
            if(item.checked){
                    item.store_kits.map(function(item2){
                        store_kits.push({"store_kit_id":item2.store_kit_id})
                        return true
                    })
            }else{
                item.store_kits.map(function(item2){
                    if(item2.checked){
                        store_kits.push({"store_kit_id":item2.store_kit_id})
                    }
                    return true
            })
            }  

             return true
        })

        let actionName="";
        if(this.state.productSelected.stock_status==="Stock In"){
            actionName="Stock Out"
        }else{
            actionName="Stock In"
        }

        let apiPayloadData={
            "stock_status":actionName,
            "store_kits":store_kits
        }

        

        apiService.postProductsStocksUpdate(apiPayloadData,this.state.productSelected.id)
            .then(responseData => {
                 this.props.dispatch(productUpdateStockTableReady(true))
                    if (responseData.status === "SUCCESS") {
                        this.props.history.push("/dashboard/products/stocks/list")
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                console.error("Error data: ", err)
               alert("exception");
            })
        
    }
   

    createCustomToolBar = props => {
        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
                <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 header-div-margins">
                    
                     <div className="col-xs-12 col-sm-12 col-md-10 header-div-margins">
                           
                        <a href="" 
                            onClick={(e) => {e.preventDefault() 
                                        this.props.history.goBack()}}> 
                                <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                        </a>
                    </div>

                   <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                   <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                e.preventDefault()
                                this.updateStock()
                            }}>
                            Update Stock
                        </button>
                    </div>

                </div>
                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 header-search-icon header-div-margins">
                    {props.components.searchPanel}
                </div>
            </div>
        )
    }
    createCustomFooter = props => {
        return (
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 footer-pagination-icons">
                    {props.components.pageList}
                </div>
            </div>
        )
    }

    getFilteredCompanyList = () => {
       
        this.props.dispatch(productUpdateStockTableReady(false))
        this.resetSearchAndPagination()
        this.getProductStocksData()
       
    }

    resetSearchAndPagination = () => {
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }

    
    resetFilterValues = () => {
        this.resetPagination()
        this.setState({
            citySelectedId: 0
        }, () => {
            this.getProductStocksData()
            this.props.dispatch(productUpdateStockTableReady(false))
            this.props.dispatch(searchTextState(""))

            this.searchBox.wrappedInstance.refs.searchInput.value = ""
            this.searchBox.props.search("")
        })
        
        
    }


     checkBoxChange = (row,e,rowIndex) => {

        let prodStocksData=this.state.productStocksData.slice();
           
             prodStocksData.map(function(item) {
                if(item.id===row.id){
                    item['checked']=e.target.checked

                    item.store_kits.map(function(item2){
                        item2['checked']=e.target.checked
                        return true;
                     })

                    
                }

                return true;

            });

             this.setState({
                productStocksData:prodStocksData
             })
        }
        





     renderCheckBox = (cell, row, enumObject, rowIndex) => {
       
        // let checkBox=<input className="checkbox form-check-input" type="checkbox" value={row.product_id} onChange={(e) => {
        //              this.checkBoxChange(row,e,rowIndex)
        //         }} checked={row.checked}/>
        
        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">

            <div class="form-check">
            
            </div>
            </div>
        </div>)
    }



     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationState(page))
        this.setState({
            page: page
        })
    }

    resetPagination = () => {
        if (this.props.products_stocks && this.props.products_stocks.previousPaginationValue
            && this.props.products_stocks.previousPaginationValue !== 1) {
            this.props.dispatch(paginationState(1))
            this.setState({
                page: 1
            })
        }
    }

    render() {
        let sizeperPage = 15

        if (this.props.products_stocks && this.props.products_stocks.previousRowsPerPageValue) {
            sizeperPage = this.props.products_stocks.previousRowsPerPageValue
        }

        const options = {
            page: this.state.page,  // which page you want to show as default
            sizePerPage: sizeperPage,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPageListPosition: 'bottom',
            sizePerPageDropDown: this.rowsperPageDropdown,
            searchPanel: (props) => (<SearchField { ...props }
                callback={this.resetPagination}
                ref={el => this.searchBox = el} />),
            toolBar: this.createCustomToolBar,
            paginationPanel: this.createCustomFooter,
            onlyOneExpanding: true,
            expandRowBgColor: '#e1e5ed',
            expandBy: 'column',  //Available value is row and column, default is row.
            onPageChange: this.onPageChange,
        }
        return (
            <div className="companies-table" style={{ marginBottom: '0px', maxHeight: this.state.bodyHeight }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    ref='table'
                    options={options}
                    data={this.state.productStocksData}
                    pagination={false}
                    expandableRow={this.isExpandableRow}
                    expandComponent={this.expandComponent}
                    hover={true}
                    search={true}
                    headerStyle={{ border: '0px', background: '#626262', color: '#fff' }}
                    tableStyle={{ border: '0px', 'background': 'white' }}
                    bodyStyle={{ border: '0px', overflow: "auto", height: this.state.tableHeight }}
                    expandColumnOptions={{
                        expandColumnVisible: true,
                        rerenderOnDataChange: true,
                        expandColumnComponent: this.expandColumnComponent,
                        columnWidth: 2
                    }}>
                    <TableHeaderColumn
                        dataField="id"
                        width="1"
                        isKey={true}
                        hidden={true}
                        expandable={false}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Id
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="kit_name"
                        width="50"
                        dataSort={true}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Kit Name
                    </TableHeaderColumn>
                       <TableHeaderColumn
                        dataFormat={this.renderCheckBox}
                        dataAlign='center'
                        width="10"
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Actions
                    </TableHeaderColumn>
                </BootstrapTable>
            </div>
        )
    }

}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        products_stocks: state.products_stocks
    }
}

export default connect(mapStateToProps)(withRouter(ProductUpdateStockTable))


// WEBPACK FOOTER //
// ./src/modules/ProductsStocks/Components/ProductUpdateStockTable.js